import styled from 'styled-components';
import Inset from 'syf-component-library/ui/spacing/Inset';
import { colors, fontWeights } from 'syf-component-library/defaultTheme';
import { Radio } from 'syf-component-library/ui/atoms';
import { RadioGroup } from 'syf-component-library/ui/patterns';
import query from 'syf-component-library/const/mediaQueries';
export const Container = styled(Inset) `
  display: flex;
  justify-content: center;
  flex-direction: column;
`;
export const UserRadioContainer = styled(Radio) `
  border-bottom: 1px solid ${colors.lightGrey};
  display: flex;
  align-items: center;
  padding: 8px;
  @media ${query.lessThanSmall} {
    padding: 8px 4px;
  }
`;
export const RadioGroupContainer = styled(RadioGroup) `
  width: 100%;
  @media ${query.greaterThanSmall} {
    ${UserRadioContainer}:first-child {
      border-top: 1px solid ${colors.lightGrey};
    }
  }
`;
export const HeaderContainer = styled(Inset) `
  display: flex;
  justify-content: space-between;
  border-top: ${props => props.borderTop ? `1px solid ${colors.lightGrey};` : ''};
  border-bottom: ${props => props.borderBottom ? `1px solid ${colors.lightGrey};` : ''};
  @media ${query.lessThanSmall} {
    display: none;
  }
`;
export const Label = styled.strong `
  font-weight: ${fontWeights.bold};
  @media ${query.greaterThanSmall} {
    display: none;
  }
`;
export const UserInfoContainer = styled.div `
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  @media ${query.lessThanSmall} {
    flex-direction: column;
  }
`;
export const UserNameContainer = styled.span `
  @media ${query.lessThanSmall} {
    width: 100%;
  }
`;
export const MembershipNumberContainer = styled.span `
  @media ${query.lessThanSmall} {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
`;
